import React, { useCallback } from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import EmptyState from '@adsk/alloy-react-empty-state';

import { useTranslation } from '../../i18n';
import { ScheduleActivityReferencePickerPlugin } from '../../types';

const ScheduleNoSearchResultsEmptyState: Exclude<
  ScheduleActivityReferencePickerPlugin['CustomPickerNoSearchResults'],
  undefined
> = ({ filters, setFilters }) => {
  const { t } = useTranslation();

  const clearFilters = useCallback(() => {
    setFilters({ scheduleId: filters.scheduleId });
  }, [filters, setFilters]);

  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_PHOTO_GREY}
      title={t('EMPTY_STATE.NO_RESULTS_TITLE')}
      description={t('EMPTY_STATE.NO_RESULTS_SUBTITLE')}
    >
      <LinkButton onClick={clearFilters}>
        {t('EMPTY_STATE.NO_RESULTS_LINK')}
      </LinkButton>
    </EmptyState>
  );
};

export default ScheduleNoSearchResultsEmptyState;
